import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Box,
  Divider,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Accordion, AccordionSummary, AccordionDetails
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import axios from "axios";
import moment from "moment";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import LinearProgress from '@mui/material/LinearProgress';
import CachedIcon from '@mui/icons-material/Cached';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";
import TenancyAgreement from "../../User/Account/TenancyAgreement";
import { display } from "@mui/system";



export default function Application() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false);
  const [hostelRoomData, setHostelRoomData] = useState({})
  const [studentData, setStudentData] = useState({})
  const [hostelData, setHostelData] = useState({})
  const [allocated, setAllocated] = useState(false)
  const contractRef = useRef(null);
  const [userData, setUserData] = useState({})

  console.log(userData)

  console.log(hostelData)

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalItems, setTotalItems] = useState(0);

  const [pageUnpaid, setPageUnpaid] = useState(0);
  const [rowsPerPageUnpaid, setRowsPerPageUnpaid] = useState(5);
  const [totalItemsUnpaid, setTotalItemsUnpaid] = useState(0);

  const [pagePaid, setPagePaid] = useState(0);
  const [rowsPerPagePaid, setRowsPerPagePaid] = useState(5);
  const [totalItemsPaid, setTotalItemsPaid] = useState(0);

  const [pageRejected, setPageRejected] = useState(0);
  const [rowsPerPageRejected, setRowsPerPageRejected] = useState(5);
  const [totalItemsRejected, setTotalItemsRejected] = useState(0);

  const [pendingData, setPendingData] = useState([]);
  const [unpaidData, setUnpaidData] = useState([]);
  const [paidData, setPaidData] = useState([]);
  const [rejectedData, setRejectedData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingUnpaid, setLoadingUnpaid] = useState(false);
  const [loadingPaid, setLoadingPaid] = useState(false);
  const [loadingRejected, setLoadingRejected] = useState(false);

  const getPendingApplication = async () => {
    setLoading(true)
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}get-pending-application?page=${
          page + 1
        }&limit=${rowsPerPage}`
      );
      setTotalItems(response.data.pagination.totalItems || 0);
      setPendingData(response?.data?.data || []);
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };


  // const getHostels = async (id) => {
  //   try {
  //     const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}gethostelbyId/${id}`)
  //     console.log(response, 'HOSTEL')
  //     if(response.status === 200){
  //       setHostelData(response?.data?.data)
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     if(error.response.status === 401 || error.response.status === 403){
  //       navigate('/Admin/login')
  //       dispatch(removeData())
  //   }
  //   }
  // }

  // useEffect(() => {
  //   console.log(hostelRoomData?.RoomsData)
  //   // if(hostelRoomData?.selectedRoom?.hostelId){
  //   //   getHostels(hostelRoomData?.selectedRoom?.hostelId)
  //   // }
  //   if(true){
  //     getHostels('67dd553d820cb73fadb2d001')
  //   }
  // }, [])

  const getUnpaidApplication = async () => {
    setLoadingUnpaid(true)
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}get-unpaid-roomrent-application?page=${
          pageUnpaid + 1
        }&limit=${rowsPerPageUnpaid}`
      );
      setTotalItemsUnpaid(response.data.pagination.totalItems || 0);
      setUnpaidData(response?.data?.data || []);
      setLoadingUnpaid(false)
    } catch (error) {
      console.log(error);
      setLoadingUnpaid(false)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  const getPaidApplication = async () => {
    setLoadingPaid(true)
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}get-paid-roomrent-application?page=${
          pagePaid + 1
        }&limit=${rowsPerPagePaid}`
      );
      setTotalItemsPaid(response.data.pagination.totalItems || 0);
      setPaidData(response?.data?.data || []);
      setLoadingPaid(false)
    } catch (error) {
      console.log(error);
      setLoadingPaid(false)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  const getRejectedApplication = async () => {
    setLoadingRejected(true)
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}get-rejected-application?page=${
          pageRejected + 1
        }&limit=${rowsPerPageRejected}`
      );
      setTotalItemsRejected(response.data.pagination.totalItems || 0);
      setRejectedData(response?.data?.data || []);
      setLoadingRejected(false)
    } catch (error) {
      console.log(error);
      setLoadingRejected(false)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePageUnpaid = (event, newPage) => {
    setPageUnpaid(newPage);
  };

  const handleChangeRowsPerPageUnpaid = (event) => {
    setRowsPerPageUnpaid(parseInt(event.target.value, 10));
    setPageUnpaid(0);
  };

  const handleChangePagePaid = (event, newPage) => {
    setPagePaid(newPage);
  };

  const handleChangeRowsPerPagePaid = (event) => {
    setRowsPerPagePaid(parseInt(event.target.value, 10));
    setPagePaid(0);
  };

  const handleChangePageRejected = (event, newPage) => {
    setPageRejected(newPage);
  };

  const handleChangeRowsPerPageRejected = (event) => {
    setRowsPerPageRejected(parseInt(event.target.value, 10));
    setPageRejected(0);
  };


  const [value, setValue] = useState(() => {
    return localStorage.getItem('tabvalue') || '1';
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    localStorage.setItem('tabvalue', value);
  }, [value]);

  useEffect(() => {
    setLoading(true);
    switch (value) {
      case '1':
        getPendingApplication();
        break;
      case '2':
        getUnpaidApplication();
        break;
      case '3':
        getPaidApplication();
        break;
      case '4':
        getRejectedApplication();
        break;
      default:
        setLoading(false);
    }
  }, [value, page, rowsPerPage, pageUnpaid, rowsPerPageUnpaid, pagePaid, rowsPerPagePaid, pageRejected, rowsPerPageRejected]);


  const tableContainer = { borderRadius: "5px", border: "1px solid #e5e5e5", boxShadow: "0px 0px 30px 20px #f4f4f4"}
  const tableCell = { borderBottom: "0.5px solid #dcdddc", py: 2.7 }
  const tableBodyCell = { minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }

  const [studentRoomData, setStudentRoomData] = useState({})



  const handleAllocateMember = (hostelTypeId, roomTypeId, roomId, newMember) => {
    console.log(hostelTypeId, roomTypeId, roomId, newMember);

   
    const studentData = {
      id : newMember?._id,
      name : newMember?.PersonalData?.Details?.name,
      gender : newMember?.PersonalData?.Details?.gender
    }

    setStudentRoomData({
      hostel_id : hostelData?.id,
      hostelTypeId,
      roomTypeId, 
      roomId,
      student_id : studentData.id
    })

    setHostelData((prevData) => {
        let updatedHostelData = { ...prevData };

        updatedHostelData.HostelTypes = updatedHostelData.HostelTypes.map((hostelType) => {
            if (hostelType.id !== hostelTypeId) return hostelType; // Only update the correct hostel type

            return {
                ...hostelType,
                room_type: hostelType.room_type.map((roomType) => {
                    if (roomType.id !== roomTypeId) return roomType; // Only update the correct room type

                    let previousRoomId = null;

                    roomType.rooms.forEach((room) => {
                        if (room.members.some((member) => member.id === studentData.id)) {
                            previousRoomId = room.id;
                        }
                    });

                    return {
                        ...roomType,
                        rooms: roomType.rooms.map((room) => {
                            if (room.id === previousRoomId) {
                                return {
                                    ...room,
                                    members: room.members.filter((member) => member.id !== studentData.id),
                                    availableSlots: room.availableSlots + 1,
                                };
                            }

                            if (room.id === roomId) {
                                return {
                                    ...room,
                                    members: [...room.members, studentData],
                                    availableSlots: room.availableSlots > 0 ? room.availableSlots - 1 : 0,
                                };
                            }

                            return room;
                        }),
                    };
                }),
            };
        });

        return updatedHostelData;
    });
};


  

  const isMemberAllotted = (newMemberId) => {
    return hostelData?.HostelTypes.some((hostelType) =>
      hostelType.room_type.some((roomType) =>
        roomType.rooms.some((room) =>
          room.members.some((member) => member.id === newMemberId)
        )
      )
    );
  };
  
  const handleBookRoom = (data) => {
    console.log(data)
      const studentData = {
        id : hostelRoomData?._id,
        name : hostelRoomData?.PersonalData?.Details?.name,
        gender : hostelRoomData?.PersonalData?.Details?.gender

      }

      console.log(data.id ,studentData)
      handleAllocateMember(data.id, studentData)
  }

  useEffect(() => {
    if (hostelRoomData?._id) {
      setAllocated(isMemberAllotted(hostelRoomData._id));
    }
  }, [hostelData]);

  const updateHostelTypes = async () => {
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}update-hostel-types/${hostelData.id}`, {
        HostelTypes : hostelData.HostelTypes,
        studentRoomData

      })

      if(response.status === 200){
        console.log(response)
        handleClose()
        // getHostels('67dd553d820cb73fadb2d001')
        setStudentRoomData({})
        toast.success("Room Allotted Successfully!")
      }
    } catch (error) {
      console.log(error)
    }
  }

   const handleContract = () => {
        if(contractRef.current){
            contractRef.current.generatePDFs()
        }
    }

  console.log(hostelData)

  return (
    <>
    <Box sx={{position : 'relative'}}>
      <Box sx={{position : 'absolute', top : '-2000000px'}}>
      {/* <PdfGenerate 
      ref={pdfRef}
      data={invoiceData}  
      invoiceNumber={paymentData?.id}
      invoiceDate={paymentData?.createdAt}
      invoiceAmount={paymentData?.amount}
      subject={`${allData?.RoomsData?.selectedRoom?.HostelName} (${allData?.RoomsData?.contractLength === 1 ? "6 Month Contract" : "12 Month Contract"})`}
      /> */}
      
      <TenancyAgreement 
        ref={contractRef}
        signatureImage={userData?.tenancyAgreement?.signature?.filename}
        allData={userData}
        />
      </Box>
      </Box>
    <ToastContainer />
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h7_1">Applications</Typography>
        {/* <Button onClick={() => navigate("AnnouncementAdd")} variant="contained">Add</Button> */}
      </Stack>
      <Divider sx={{ mb: 3, mt: 2 }} />
      <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab sx={{ textTransform: 'none', fontSize : '1.1rem' }} label="Pending" value="1" />
            <Tab sx={{ textTransform: 'none', fontSize : '1.1rem' }} label="Unpaid - Room rent" value="2" />
            <Tab sx={{ textTransform: 'none', fontSize : '1.1rem' }} label="Paid - Room rent" value="3" />
            <Tab sx={{ textTransform: 'none', fontSize : '1.1rem' }} label="Rejected" value="4" />
          </TabList>
        </Box>
        <TabPanel value="1" sx={{pt : 4, px : 0}}>
        <TableContainer sx={tableContainer}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={tableCell}>
                <Typography variant="h9_1" color="#333333">
                  Name
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Gender
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Hostel name
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Date & Time
                </Typography>
              </TableCell>
              <TableCell sx={{...tableCell, cursor : 'pointer'}} onClick={() => getPendingApplication()}>
                {" "}
                <Typography variant="h9_1" color="#333333"><CachedIcon /></Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan={5} sx={{p :0, borderBottom : '0px'}}>
              <LinearProgress color="primary" />
              </TableCell>
              </TableRow>
            )}
          {pendingData.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} sx={tableBodyCell}>
            <Typography>No data found</Typography>
            </TableCell>
            </TableRow>
          ) : (
            pendingData
              .map((item, index) => (
              <TableRow
                key={item.name}
                sx={{
                  border: "0px",
                  backgroundColor: index % 2 === 0 ? "#f8f8f8" : "white", 
                }}
                // onClick={() => navigate(`/Admin/ApplicationView/${item?._id}`)}
              >
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.PersonalData?.Details?.name || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.PersonalData?.Details?.gender || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.RoomsData?.selectedRoom?.HostelName || "_"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {moment(item?.createdAt).format("MMM DD YYYY , hh:mm A") || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Button
                    variant="contained"
                    onClick={() =>
                      navigate(`/Admin/ApplicationView/${item?._id}`, {state : {status : 'Pending' }})
                    }
                  >
                    Review
                  </Button>
                </TableCell>
              </TableRow>
            )))}
          </TableBody>
        </Table>
        
        <TablePagination
          component="div"
          count={totalItems} 
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </TableContainer>
        </TabPanel>
        
        <TabPanel value="2" sx={{pt : 4, px : 0}}>
        <TableContainer sx={tableContainer}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={tableCell}>
                <Typography variant="h9_1" color="#333333">
                  Name
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Gender
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Hostel name
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Date & Time
                </Typography>
              </TableCell>
              <TableCell sx={{...tableCell, cursor : 'pointer'}} onClick={() => getUnpaidApplication()}>
                {" "}
                <Typography variant="h9_1" color="#333333"><CachedIcon /></Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loadingUnpaid && (
              <TableRow>
                <TableCell colSpan={5} sx={{p :0, borderBottom : '0px'}}>
              <LinearProgress color="primary" />
              </TableCell>
              </TableRow>
            )}
          {unpaidData.length === 0 ? (<>
          <TableRow>
            <TableCell colSpan={5} sx={tableBodyCell}>
              <Typography>No data found</Typography>
            </TableCell>
          </TableRow>
          </>) : (
            unpaidData.map((item, index) => (
              <TableRow
                key={item.name}
                sx={{
                  border: "0px",
                  backgroundColor: index % 2 === 0 ? "#f8f8f8" : "white", 
                }}
                // onClick={() => navigate(`/Admin/ApplicationView/${item?._id}`, {state : {status : 'Unpaid' }})}
              >
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.PersonalData?.Details?.name || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.PersonalData?.Details?.gender || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.RoomsData?.selectedRoom?.HostelName || "_"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {moment(item?.createdAt).format("MMM DD YYYY , hh:mm A") || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{...tableBodyCell, display : 'flex', flexDirection : 'column', gap : '.5rem', alignItems : 'center'}}>
                  <Button
                    variant="contained"
                    onClick={() =>
                      navigate(`/Admin/ApplicationView/${item?._id}`, {state : {status : 'Unpaid' }})
                    }
                  >
                    Review
                  </Button>
                  {/* {item?.allocatedRoomData?.hostel_id ? (
                    <>
                    <Button sx={{border : '1px solid green',backgroundColor : 'green', color : 'white', fontSize : '1rem'}}>Room Allocated</Button>
                    </>
                  ) : (
                      <Button
                      variant="contained"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleClickOpen()
                        setHostelRoomData(item)
                      }}
                      >
                      Allot Room
                      </Button>
                  )} */}
                  
                </TableCell>
              </TableRow>
            )))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={totalItemsUnpaid} 
          page={pageUnpaid}
          onPageChange={handleChangePageUnpaid}
          rowsPerPage={rowsPerPageUnpaid}
          onRowsPerPageChange={handleChangeRowsPerPageUnpaid}
          rowsPerPageOptions={[5, 10, 25]}
        />

      </TableContainer>
        </TabPanel>
        
        
        <TabPanel value="3" sx={{pt : 4, px : 0}}>
        <TableContainer sx={tableContainer}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={tableCell}>
                <Typography variant="h9_1" color="#333333">
                  Name
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Gender
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Hostel name
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Date & Time
                </Typography>
              </TableCell>
              <TableCell sx={{...tableCell, cursor : 'pointer'}} onClick={() => getPaidApplication()}>
                {" "}
                <Typography variant="h9_1" color="#333333"><CachedIcon /></Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loadingPaid && (
              <TableRow>
                <TableCell colSpan={5} sx={{p :0, borderBottom : '0px'}}>
              <LinearProgress color="primary" />
              </TableCell>
              </TableRow>
            )}
          {paidData.length === 0 ? (<>
          <TableRow>
            <TableCell colSpan={5} sx={tableBodyCell}>
              <Typography>No data found</Typography>
            </TableCell>
          </TableRow>
          </>) : (
            paidData.map((item, index) => (
              <TableRow
                key={item.name}
                sx={{
                  border: "0px",
                  backgroundColor: index % 2 === 0 ? "#f8f8f8" : "white", 
                }}
                // onClick={() => navigate(`/Admin/ApplicationView/${item?._id}`, {state : {status : 'Paid' }})}
              >
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.PersonalData?.Details?.name || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.PersonalData?.Details?.gender || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.RoomsData?.selectedRoom?.HostelName || "_"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {moment(item?.createdAt).format("MMM DD YYYY , hh:mm A") || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{...tableBodyCell, display : 'flex', justifyContent : 'space-between', gap : 2, alignItems : 'center'}}>
                  <Button
                    variant="contained"
                    onClick={() =>
                      navigate(`/Admin/ApplicationView/${item?._id}`, {state : {status : 'Paid' }})
                    }
                  >
                    View
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setUserData(item);
                      setTimeout(() => {
                        handleContract(); 
                      }, 100); 
                    }}
                  >
                    Contract
                  </Button>
                </TableCell>
              </TableRow>
            )))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={totalItemsPaid} 
          page={pagePaid}
          onPageChange={handleChangePagePaid}
          rowsPerPage={rowsPerPagePaid}
          onRowsPerPageChange={handleChangeRowsPerPagePaid}
          rowsPerPageOptions={[5, 10, 25]}
        />

      </TableContainer>     
        </TabPanel>
        
        <TabPanel value="4" sx={{pt : 4, px : 0}}>
        <TableContainer sx={tableContainer}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={tableCell}>
                <Typography variant="h9_1" color="#333333">
                  Name
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Gender
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Hostel name
                </Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Date & Time
                </Typography>
              </TableCell>
              <TableCell sx={{...tableCell, cursor : 'pointer'}} onClick={() => getRejectedApplication()}>
                {" "}
                <Typography variant="h9_1" color="#333333"><CachedIcon /></Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loadingRejected && (
              <TableRow>
                <TableCell colSpan={5} sx={{p :0, borderBottom : '0px'}}>
              <LinearProgress color="primary" />
              </TableCell>
              </TableRow>
            )}
          {rejectedData.length === 0 ?
            (<>
              <TableRow>
                <TableCell colSpan={5} sx={tableBodyCell}>
                  <Typography>No data found</Typography>
                </TableCell>
              </TableRow>
            </>) : (
            rejectedData.map((item, index) => (
              <TableRow
                key={item.name}
                sx={{
                  border: "0px",
                  backgroundColor: index % 2 === 0 ? "#f8f8f8" : "white", 
                }}
                // onClick={() => navigate(`/Admin/ApplicationView/${item?._id}`, {state : {status : 'Reject'}})}
              >
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.PersonalData?.Details?.name || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.PersonalData?.Details?.gender || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.RoomsData?.selectedRoom?.HostelName || "_"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Typography variant="h9_4" color="#333333">
                    {moment(item?.createdAt).format("MMM DD YYYY , hh:mm A") || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={tableBodyCell}>
                  <Button
                    variant="contained"
                    onClick={() =>
                      navigate(`/Admin/ApplicationView/${item?._id}`, {state : {status : 'Reject' }})
                    }
                  >
                    Review
                  </Button>

                  
                </TableCell>
              </TableRow>
            )))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={totalItemsRejected} 
          page={pageRejected}
          onPageChange={handleChangePageRejected}
          rowsPerPage={rowsPerPageRejected}
          onRowsPerPageChange={handleChangeRowsPerPageRejected}
          rowsPerPageOptions={[5, 10, 25]}
        />

      </TableContainer>
        </TabPanel>
      </TabContext>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{width : '100%'}}
        maxWidth="md"
        fullWidth
      >
        <Box sx={{boxShadow: '0px 0px 5px 0.5px rgba(255, 255, 255, 0.5)', position : 'sticky', top : 0, backgroundColor : 'white' ,p: 2, zIndex : 100, display : 'flex', justifyContent : 'space-between'}}>
      <Typography variant="h5">Allot Room</Typography>
      <Button sx={{color : 'black'}} onClick={() => handleClose()}><CloseIcon /></Button>
      </Box>

      
      <Box sx={{ width: "100%", padding: "20px" }}>
      <Box sx={{mb: 2}}>
        <Typography sx={{fontWeight : 700, fontSize : '1.2rem'}}>Room Types</Typography>
      </Box>
  {hostelData?.HostelTypes?.map((hostel) =>
    hostel.room_type.map((type) => (
      <Accordion key={type.room_type_name}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6" sx={{fontWeight : 700}}>{type.room_type_name}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {type.rooms.map((room) => (
            <Card key={room.id} sx={{ margin: "10px", padding: "10px" }}>
              <CardContent>
                <Box sx={{ display: "flex", gap: "50px", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography variant="h6">{room.roomName}</Typography>
                  <Typography>Available Slots: {room.availableSlots}</Typography>
                </Box>
                <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}>
                <Checkbox
                      checked={room.members.some((m) => m.id === hostelRoomData?._id)}
                      onChange={(e) =>
                        handleAllocateMember(hostel.id, type.id, room.id, hostelRoomData)
                      }
                      disabled={room.availableSlots === 0}
                      sx={{
                        color: room.availableSlots === 0 ? "grey" : "primary.main",
                        "&.Mui-disabled": { color: "rgba(0, 0, 0, 0.26)" },
                        "&.Mui-checked": {
                          color: room.availableSlots === 0 ? "grey" : "primary.main",
                        },
                      }}
                    />
                </Box>
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body1">
                    <b>Members:</b>{" "}
                    {room.members && room.members.length > 0
                      ? (Array.isArray(room.members) ? room.members : JSON.parse(room.members || "[]"))
                          .map((m) => `${m.name} (${m.gender})`)
                          .join(", ")
                      : "No members yet"}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          ))}
        </AccordionDetails>
      </Accordion>
    ))
  )}
</Box>
    <Box sx={{boxShadow : '0px -8px 43px -21px rgba(179,179,179,1)',  p : 2, position : 'sticky', bottom : 0, display : 'flex', justifyContent : 'flex-end', backgroundColor : 'white'}}>
                  <Button variant="contained" disabled={!allocated} onClick={() => updateHostelTypes()}>Book Now</Button>
        </Box>
      </Dialog>
    </Box> 
    </>
  );
}
